<div class="container-fluid">
  <div class="row">
    <div class="col-10">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Journal Voucher</h4>
      </div>
    </div>
    <div class="col-2">
    </div>
  </div>
<br>
  <!-- <app-pagetitle title="Customer Quotation" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> -->
  <!-- <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="AccCode">Customer Name</label>
                <ng-select name="AccCode" [items]="JournalList" bindLabel="AccName" bindValue="Amid"
               [disabled]="checkAccDisabled()"   [(ngModel)]="selectedAccID2"></ng-select>
                <div class="invalid-feedback" *ngIf="checkSupplier2()">
                  Please provide Customer
                </div>
              </div>
            </div>
          </div>
                    <h4 class="card-title">Select Product</h4>
          <div class="card">
            <input class="form-control" [(ngModel)]="searchSize" placeholder="Size" id="searchSize" name="searchSize"
              (keydown.enter)="searchPrdFromDB($event)" />


          </div>
          <div *ngIf="SearchPanelVisible" class="table-responsive">
            <table class="table table-hover mb-0">

              <thead>
                <tr class="TableHeaderRow">
                  <th>#</th>
                  <th>Description</th>
                  <th>Order No</th>
                  <th>Order Date</th>
                  <th>Order Qty</th>
                  <th>Booked Qty</th>
                  <th>Invoice Qty</th>
                  <th>Rate</th>
                  <th>Volume</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of SearchItems;let i=index">
                  <th scope="row">{{i+1}}</th>
                  <td>{{item.Description}}</td>
                  <td>{{item.OrderNo}}</td>
                  <td>{{item.OrderDate}}</td>
                  <td>{{item.OrderQty}}</td>
                  <td>{{item.BookedQty}}</td>
                  <td>
                    <input type="number" class="form-control" id="InvoiceQty + {{item.id}}" value="0"
                      [(ngModel)]="item.InvoiceQty">
                  </td>
                  <td>{{item.OrderRate}}</td>
                  <td>{{item.PurQty/item.PrdContainerCapacity | number : '.2-2'}}</td>
                  <td>
                    <input type="text" class="form-control" id="Remarks + {{item.id}}" value="0"
                      [(ngModel)]="item.Remarks">
                  </td>
                </tr>
                <tr class="TotalRow">
                  <td></td>
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td>{{productTotal.POQty}}</td>
                  <td>{{productTotal.BookedQty}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div class="row">
              <div class="col-lg-10"></div>
              <div class="col-lg-2">
                <button class="btn btn-warning" (click)="addProducts()">Add & Continue</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  </div> -->
   <form class="needs-validation" (ngSubmit)="validSubmit()" [formGroup]="validationform"> 

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">

              <!-- <div class="col-md-5">
                <div class="form-group">
                  <label for="a_code">Journal Name</label>
                  <ng-select formControlName="a_code" name="a_code" id="a_code"
                (change)="getVoucherDetailList()"    [items]="JournalList"  
                bindLabel="AccName" bindValue="AccCode" 
                    [(ngModel)]="selectedAccID"></ng-select>
                  <div class="invalidValidate" *ngIf="checkSupplier()">
                    Please provide Journal Name
                  </div>
                </div>

              </div>
               -->

              <div class="col-md-3">
                <div class="form-group">
                  <label for="V_NO">Voucher No</label>
                  <input class="form-control" formControlName="V_NO" id="V_NO"
                 disabled readonly   [ngClass]="{'is-invalid': submit && form.V_NO.errors}">
                  <div *ngIf="submit && form.V_NO.errors" class="invalid-feedback">
                    Please provide Voucher No
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="DATED">Payment Date</label>
                  <input type="date" class="form-control" formControlName="DATED"
                   id="DATED"
                    [ngClass]="{'is-invalid': submit && form.DATED.errors}">
                  <div *ngIf="submit && form.DATED.errors" class="invalid-feedback">
                    Please provide Date
                  </div>  
                </div>
              </div>
            </div>
                  <!-- <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="MasterRemarks">Remarks</label>
                  <input type="text" class="form-control" formControlName="MasterRemarks" id="MasterRemarks">
                </div>
              </div>
            </div> -->
              
            
          </div>
        </div>
        <!-- end card -->
      </div> <!-- end col -->


    </div>
   </form>
    <div class="row" >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" >
            <h4 class="card-title">Payment Detail</h4>

            <div class="table-responsive" style="min-height:250px ;">
              <table class="table table-hover mb-0">

                <thead>
                  <tr class="TableHeaderRow">
                    <th>#</th>
                    <th style="min-width:250px!important">Account Name</th>
                    <th style="min-width:250px!important">Narration</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of VoucherDetailList;let i=index">
                    <td>{{i+1}}</td>
                    <td>
                      <ng-select name="AccountList" id="AccountList + {{item.id}}"
                      [items]="AccountList"  bindLabel="Name" bindValue="Code" 
                      (change)="checkLastRow(i)" [(ngModel)]="item.a_code"></ng-select>
                    </td>
                    <td>
                        <input class="form-control" id="NARRATION + {{item.id}}" value=""
                        [(ngModel)]="item.NARRATION"></td>
                    <td>
                      <input type="number" class="form-control" id="DEBIT + {{item.id}}" value="0"
                      [(ngModel)]="item.DEBIT"></td>
                    <td>
                      <input type="number" class="form-control" id="CREDIT + {{item.id}}" value="0"
                      [(ngModel)]="item.CREDIT"></td>
                      <td>
                      <button type="button" class="mdi mdi-18px mdi-delete text-danger"
                        (click)="DeletePrdItem(item,i)"></button>
                    </td>
                  </tr>
                  <tr class="TotalRow">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>


    </div>

 
  
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">

              <div class="col-md-8">
                <div class="form-group">
                  <!-- <label for="PaymentTerms">Remarks</label>
                  <textarea rows="4" class="form-control" formControlName="PaymentTerms" id="PaymentTerms"></textarea> -->
                </div>
              </div>
              
                <div class="col-lg-2">
                </div>
                  <div class="col-lg-2">
                  <br>
                  <div class="card">
                    <button class="btn btn-primary " (click)="validSubmit()">Save</button>
                </div>
              </div>
        

            </div>
            </div>
      
            
            
        </div>
        <!-- end card -->
      </div> <!-- end col -->


    </div>
    <!-- end row -->

  <!-- </form> -->


</div>